export default "__VITE_ASSET__mnh4T78b__"